import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
import Calendar from '@/components/pages/Calendar'
import Appointments from '@/components/pages/Appointments'
import Appointment from '@/components/pages/Appointment'
import Clients from '@/components/pages/Clients'
import Client from '@/components/pages/Client'
import ClientHome from '@/components/pages/ClientHome'
// import ClientRecord from '@/components/pages/ClientRecord'
// import ClientsMerge from '@/components/client/merge'
import Invoices from '@/components/pages/Invoices'
import Invoice from '@/components/pages/Invoice'
import Financials from '@/components/pages/Financials'
import Transactions from '@/components/invoice/layout/Transactions'

// import CreateInvoice from '@/components/invoice/Create'
// import NewInvoice from '@/components/pages/NewInvoice'
import Reports from '@/components/pages/Reports'
import Billing from '@/components/pages/Billing'

// integrations:
// import IntegrationsPage from '@/components/pages/Integrations/index'
import IntegrationsHome from '@/components/pages/Integrations/IntegrationsList'
// import NetCash from '@/components/pages/Integrations/NetCash'

// guides:
// import Guides from '@/components/pages/Guides'
// import ConfigureGuide from '@/components/pages/guides/ConfigureGuide'
// import GettingStartedGuide from '@/components/pages/guides/GettingStarted'
import GetStarted from '@/components/pages/guides/GetStarted.vue'

import Settings from '@/components/pages/Settings'
// import SettingsHome from '@/components/pages/settings/Home'
import ProductWizard from '@/components/pages/settings/locations/ProductWizard'
import Profile from '@/components/pages/settings/Profile'
// import Media from '@/components/pages/settings/Media'
// import Cards from '@/components/pages/settings/Cards'
import Earn from '@/components/pages/settings/Earn'
// import Communications from '@/components/pages/settings/communications/Communications'
import Online from '@/components/pages/settings/Online'
import CalendarFeed from '@/components/pages/settings/Calendar'
import CommunicationsPage from '@/components/pages/communications'

// import TestPage from '@/components/pages/TestPage'
import Login from '@/components/pages/Login'
import Auth from '@/mixins/Auth'

Vue.use(Router)

export const ROUTES = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      icon: 'home',
      with_datepicker: false,
      helpdocs: 'contextualhelphomepage'
    },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar,
    meta: {
      icon: 'today',
      with_datepicker: false,
      helpdocs: 'contextualhelpappointmentspage"'
    },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/calendar/team/:page?',
    name: 'TeamCalendar',
    props: true,
    component: () => import(/* webpackChunkName: "team-view" */ '../components/calendar/TeamView.vue'),
    meta: {
      icon: 'today',
      with_datepicker: false,
      hidden_from_nav: true,
      helpdocs: 'contextualhelpappointmentspage"'
    },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/appointments',
    name: 'Appointments',
    component: Appointments,
    meta: { icon: 'alarm_on', hidden_from_nav: false, with_datepicker: false, new: false, klass: 'hidden-xs-only' },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/appointments/:id',
    name: 'Appointment',
    component: Appointment,
    meta: { icon: 'alarm_on', hidden_from_nav: true, with_back_btn: true, with_datepicker: false },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/clients',
    name: 'Clients',
    component: Clients,
    meta: { icon: 'group', with_datepicker: true },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/clients/home',
    name: 'ClientsHome',
    component: ClientHome,
    meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true, with_datepicker: true },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/clients/merge/:relationshipId?',
    name: 'ClientsMerge',
    props: true,
    // component: ClientsMerge,
    component: () => import(/* webpackChunkName: "mergeclients" */ './../components/client/merge/index.vue'),
    meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true, with_datepicker: false },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/clients/r/:relationshipId',
    name: 'ClientByRelationship',
    component: Client,
    meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/clients/r/:relationshipId/:tab',
    name: 'ClientByRelationshipWithTab',
    component: Client,
    meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/clients/:id',
    name: 'Client',
    component: Client,
    meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true },
    beforeEnter: Auth.loginRequired
  },
  {
    path: '/clients/:id/:tab',
    name: 'ClientWithTab',
    component: Client,
    meta: { icon: 'group', hidden_from_nav: true, with_back_btn: true },
    beforeEnter: Auth.loginRequired
  },
  {
    name: 'Invoices',
    path: '/invoices',
    component: Invoices,
    meta: {
      icon: 'content_copy',
      with_datepicker: true,
      helpdocs: 'contextualhelpinvoicespage'
    },
    beforeEnter: Auth.loginRequired
  },
  {
    name: 'Transactions',
    path: '/transactions',
    component: Transactions,
    meta: {
      hidden_from_nav: true,
      icon: 'content_copy',
      with_datepicker: true
    },
    beforeEnter: Auth.loginRequired
  },
  {
    name: 'Financials',
    path: '/financials',
    component: Financials,
    meta: { hidden_from_nav: true, icon: 'content_copy', with_datepicker: true },
    beforeEnter: Auth.loginRequired
  },
  {
    name: 'Messages',
    path: '/messages',
    component: CommunicationsPage,
    meta: { hidden_from_nav: false, icon: 'send', with_datepicker: false },
    beforeEnter: Auth.loginRequired
  },
  // { name: 'CreateInvoice',
  //   path: '/invoices/new',
  //   component: CreateInvoice,
  //   meta: { icon: 'content_copy', hidden_from_nav: true, with_datepicker: false },
  //   beforeEnter: Auth.loginRequired
  // },
  // { name: 'NewInvoice',
  //   path: '/invoices/:id/new',
  //   component: NewInvoice,
  //   meta: { icon: 'content_copy', hidden_from_nav: true, with_back_btn: true, with_datepicker: false },
  //   beforeEnter: Auth.loginRequired
  // },
  {
    name: 'EditInvoice',
    path: '/invoices/:id',
    component: Invoice,
    meta: { icon: 'content_copy', hidden_from_nav: true, with_back_btn: true, with_datepicker: false },
    beforeEnter: Auth.loginRequired
  },
  {
    name: 'Reports',
    path: '/reports',
    component: Reports,
    meta: { icon: 'trending_up', with_datepicker: true },
    beforeEnter: Auth.loginRequired
  },
  {
    name: 'Free Stuff',
    path: '/settings/earn',
    component: Earn,
    meta: { icon: 'attach_money', with_datepicker: false, new: false },
    beforeEnter: Auth.loginRequired
  },
  {
    name: 'Settings',
    path: '/settings',
    redirect: '/settings/profile',
    component: Settings,
    meta: { icon: 'settings', showChildren: true, with_datepicker: false, updated: true },
    beforeEnter: Auth.loginRequired,
    children: [
      {
        name: 'Home',
        path: '/settings/home',
        component: ProductWizard,
        meta: { icon: 'home', with_datepicker: false, hidden_from_nav: true },
        beforeEnter: Auth.loginRequired
      },
      {
        name: 'Spaces',
        path: '/settings/locations',
        component: ProductWizard,
        meta: { icon: 'location_on', with_datepicker: false },
        beforeEnter: Auth.loginRequired
      },
      {
        name: 'Profile',
        path: '/settings/profile',
        component: Profile,
        meta: { icon: 'person', with_datepicker: false },
        beforeEnter: Auth.loginRequired
      },
      // {
      //   name: 'Media',
      //   path: '/settings/media',
      //   component: Media,
      //   meta: { icon: 'add_a_photo', with_datepicker: false },
      //   beforeEnter: Auth.loginRequired
      // },
      // {
      //   name: 'Notifications',
      //   path: '/settings/notifications',
      //   component: Communications,
      //   meta: { icon: 'message', with_datepicker: false },
      //   beforeEnter: Auth.loginRequired
      // },
      {
        name: 'Get Online',
        path: '/settings/get-online',
        component: Online,
        meta: { icon: 'link', with_datepicker: false },
        beforeEnter: Auth.loginRequired
      },
      // {
      //   name: 'Cards and branding',
      //   path: '/settings/cards-and-branding',
      //   component: Cards,
      //   meta: { icon: 'star_rate', with_datepicker: false, hidden_from_nav: true },
      //   beforeEnter: Auth.loginRequired
      // },
      {
        name: 'For your phone',
        path: '/settings/calendar-feed',
        component: CalendarFeed,
        meta: { icon: 'smartphone', with_datepicker: false },
        beforeEnter: Auth.loginRequired
      },
      {
        name: 'Billing',
        path: '/billing',
        component: Billing,
        meta: { icon: 'credit_card', hidden_from_nav: false },
        beforeEnter: Auth.loginRequired
      }
    ]
  },
  {
    name: 'Configure your account',
    path: '/guides/configure',
    redirect: to => {
      return { path: '/get-started' }
    },
    meta: { icon: 'help', showChildren: true, with_datepicker: false },
    beforeEnter: Auth.loginRequired
  },
  {
    name: 'Get Started',
    path: '/get-started',
    component: GetStarted,
    meta: { icon: 'help', showChildren: true, with_datepicker: false },
    beforeEnter: Auth.loginRequired
  },
  // { name: 'Guides',
  //   path: '/guides',
  //   component: Guides,
  //   meta: { icon: 'help', showChildren: true, with_datepicker: false },
  //   beforeEnter: Auth.loginRequired,
  //   children: [
  //     {
  //       name: 'Configure your account',
  //       path: '/guides/configure',
  //       component: ConfigureGuide,
  //       meta: { icon: 'check', with_datepicker: false, hidden_from_nav: false },
  //       beforeEnter: Auth.loginRequired
  //     }
  // {
  //   name: 'Getting Started',
  //   path: '/guides/getting-started',
  //   component: GettingStartedGuide,
  //   meta: { icon: 'check', with_datepicker: false, hidden_from_nav: false },
  //   beforeEnter: Auth.loginRequired
  // },
  // {
  //   name: 'Invoicing',
  //   path: '/guides/invoicing',
  //   component: GettingStartedGuide,
  //   meta: { icon: 'check', with_datepicker: false, hidden_from_nav: false },
  //   beforeEnter: Auth.loginRequired
  // },
  // {
  //   name: 'Online bookings',
  //   path: '/guides/online',
  //   component: GettingStartedGuide,
  //   meta: { icon: 'check', with_datepicker: false, hidden_from_nav: false },
  //   beforeEnter: Auth.loginRequired
  // }
  //   ]
  // },
  {
    path: '/integrations',
    name: 'Integrations',
    // component: IntegrationsPage,
    component: () => import(/* webpackChunkName: "integrations" */ '../components/pages/Integrations/index.vue'),
    meta: { icon: 'device_hub', showChildren: false, hidden_from_nav: false, with_back_btn: true, updated: false, with_datepicker: false },
    beforeEnter: Auth.loginRequired,
    children: [
      {
        path: '/',
        name: 'Integrations',
        component: IntegrationsHome,
        meta: { icon: 'device_hub', hidden_from_nav: false, with_back_btn: true, new: false, with_datepicker: false },
        beforeEnter: Auth.loginRequired
      },
      // {
      //   path: '/integrations/netcash',
      //   name: 'Netcash integration',
      //   component: NetCash,
      //   meta: { icon: 'device_hub', hidden_from_nav: true, with_back_btn: true, new: true, with_datepicker: false },
      //   beforeEnter: Auth.loginRequired
      // },
      {
        path: 'setmore',
        name: 'Setmore integration',
        component: () => import(/* webpackChunkName: "integrations-setmore" */ '../components/pages/Integrations/Setmore/index.vue'),
        meta: { hidden_from_nav: true, with_back_btn: true, new: true, with_datepicker: false },
        beforeEnter: Auth.loginRequired
      },
      {
        path: 'yoco',
        name: 'Yoco integration',
        component: () => import(/* webpackChunkName: "integrations-yoco" */ '../components/pages/Integrations/Yoco.vue'),
        meta: {
          hidden_from_nav: true,
          with_back_btn: true,
          new: true,
          with_datepicker: false,
          installHelp: 'https://help.appointmentguru.co/using-yoco-with-appointmentguru.html'
        },
        beforeEnter: Auth.loginRequired
      },
      {
        path: 'mailchimp',
        name: 'Mailchimp integration',
        component: () => import(/* webpackChunkName: "integrations-mailchimp" */ '../components/pages/Integrations/Mailchimp/index.vue'),
        meta: {
          hidden_from_nav: true,
          with_back_btn: true,
          new: false,
          with_datepicker: false,
          installHelp: 'https://help.appointmentguru.co/using-mailchimp-with-appointmentguru.html'
        },
        beforeEnter: Auth.loginRequired
      },
      {
        path: 'jotform',
        name: 'JotForm integration',
        component: () => import(/* webpackChunkName: "integrations-jotform" */ '../components/pages/Integrations/JotForm/index.vue'),
        meta: {
          hidden_from_nav: true,
          with_back_btn: true,
          new: false,
          with_datepicker: false,
          intallHelp: 'https://help.appointmentguru.co/courses/go-paperless-with-appointmentguru-and-jotform.html'
        },
        beforeEnter: Auth.loginRequired
      },
      {
        path: 'physitrack',
        name: 'Physitrack integration',
        component: () => import(/* webpackChunkName: "integrations-physitrack" */ '../components/pages/Integrations/Physitrack/index.vue'),
        meta: {
          hidden_from_nav: true,
          with_back_btn: true,
          new: true,
          with_datepicker: false,
          installHelp: 'https://help.appointmentguru.co/integrate-appointmentguru-with-physitrack.html'
        },
        beforeEnter: Auth.loginRequired
      }
    ]
  },
  {
    name: 'TestPage',
    path: '/test',
    // component: TestPage,
    component: () => import(/* webpackChunkName: "testpage" */ '../components/pages/TestPage.vue'),
    meta: { hidden_from_nav: true, with_datepicker: true }
    // beforeEnter: Auth.loginRequired
  },
  {
    name: 'Login',
    path: '/login',
    component: Login,
    meta: { icon: 'settings', hidden_from_nav: true, with_back_btn: false }
  },
  {
    name: 'Logout',
    path: '/logout',
    // component: TestPage,
    component: () => import(/* webpackChunkName: "logout" */ '../components/pages/Logout.vue'),
    meta: { hidden_from_nav: true, with_datepicker: false }
    // beforeEnter: Auth.loginRequired
  }
]

export default new Router({
  routes: ROUTES
})



// WEBPACK FOOTER //
// ./src/router/index.js